// Canonical partner assessment catalog. Dropdowns start from this list so
// every role is available even when the tests endpoint returns a short or
// empty catalog. Credits are overwritten when the API returns the same role.
export const PARTNER_ROLE_CATALOG = [
  { t: "Backend Developer", c: 4, kind: "sjt", group: "Technology & Digital" },
  { t: "Frontend Developer", c: 4, kind: "sjt", group: "Technology & Digital" },
  { t: "Mobile Developer", c: 4, kind: "sjt", group: "Technology & Digital" },
  { t: "Software Engineer", c: 4, kind: "sjt", group: "Technology & Digital" },
  { t: "Full Stack Developer", c: 5, kind: "sjt", group: "Technology & Digital" },
  { t: "Data Analyst", c: 3, kind: "sjt", group: "Technology & Digital" },
  { t: "Data Scientist", c: 5, kind: "sjt", group: "Technology & Digital" },
  { t: "Data Engineer", c: 5, kind: "sjt", group: "Technology & Digital" },
  { t: "AI Engineer", c: 6, kind: "sjt", group: "Technology & Digital" },
  { t: "Machine Learning Engineer", c: 6, kind: "sjt", group: "Technology & Digital" },
  { t: "Networking Hardware Specialist", c: 3, kind: "sjt", group: "Technology & Digital" },
  { t: "DevOps Engineer", c: 5, kind: "sjt", group: "Technology & Digital" },
  { t: "Cloud Engineer", c: 5, kind: "sjt", group: "Technology & Digital" },
  { t: "Information Security Specialist", c: 4, kind: "sjt", group: "Technology & Digital" },
  { t: "Cybersecurity Specialist", c: 5, kind: "sjt", group: "Technology & Digital" },
  { t: "QA Engineer", c: 3, kind: "sjt", group: "Technology & Digital" },
  { t: "Lead QA Engineer", c: 4, kind: "sjt", group: "Technology & Digital" },
  { t: "IT Specialist", c: 2, kind: "sjt", group: "Technology & Digital" },
  { t: "Project Manager", c: 3, kind: "sjt", group: "Business & Finance" },
  { t: "Operations Manager", c: 4, kind: "sjt", group: "Business & Finance" },
  { t: "Business Development Manager", c: 4, kind: "sjt", group: "Business & Finance" },
  { t: "Product Manager", c: 5, kind: "sjt", group: "Business & Finance" },
  { t: "Audit Trainee", c: 1, kind: "sjt", group: "Business & Finance" },
  { t: "Accountant", c: 2, kind: "sjt", group: "Business & Finance" },
  { t: "Financial Analyst", c: 3, kind: "sjt", group: "Business & Finance" },
  { t: "Finance Manager", c: 4, kind: "sjt", group: "Business & Finance" },
  { t: "Wealth Advisor", c: 4, kind: "sjt", group: "Business & Finance" },
  { t: "Portfolio Manager", c: 5, kind: "sjt", group: "Business & Finance" },
  { t: "Administration Assistant", c: 1, kind: "sjt", group: "Business & Finance" },
  { t: "Personal Assistant", c: 1, kind: "sjt", group: "Business & Finance" },
  { t: "Administrative Secretary", c: 1, kind: "sjt", group: "Business & Finance" },
  { t: "Executive Assistant", c: 2, kind: "sjt", group: "Business & Finance" },
  { t: "Recruiter", c: 2, kind: "sjt", group: "Business & Finance" },
  { t: "HR Officer / HR Manager", c: 3, kind: "sjt", group: "Business & Finance" },
  { t: "UI/UX Designer", c: 3, kind: "sjt", group: "Creative & Design" },
  { t: "Product Designer", c: 4, kind: "sjt", group: "Creative & Design" },
  { t: "Digital Marketer", c: 2, kind: "sjt", group: "Creative & Design" },
  { t: "Marketing Manager", c: 3, kind: "sjt", group: "Creative & Design" },
  { t: "Marketing & Communications Manager", c: 4, kind: "sjt", group: "Creative & Design" },
  { t: "Writer", c: 2, kind: "sjt", group: "Creative & Design" },
  { t: "Architect", c: 4, kind: "sjt", group: "Creative & Design" },
  { t: "Sales Representative", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Sales Associate (Banking)", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Sales Engineer", c: 3, kind: "sjt", group: "Sales & Operations" },
  { t: "Real Estate Sales Representative", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Customer Service Representative", c: 1, kind: "sjt", group: "Sales & Operations" },
  { t: "Call Centre Agent", c: 1, kind: "sjt", group: "Sales & Operations" },
  { t: "Call Centre Supervisor", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Call Centre Manager", c: 3, kind: "sjt", group: "Sales & Operations" },
  { t: "Bank Teller", c: 1, kind: "sjt", group: "Sales & Operations" },
  { t: "Fund Transfer Officer", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Banking Customer Service", c: 1, kind: "sjt", group: "Sales & Operations" },
  { t: "Dispatch Rider", c: 1, kind: "sjt", group: "Sales & Operations" },
  { t: "Site Acquisition Agent", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Facility Manager", c: 3, kind: "sjt", group: "Sales & Operations" },
  { t: "Mechanical Technician", c: 2, kind: "sjt", group: "Sales & Operations" },
  { t: "Workshop Lead Technician", c: 3, kind: "sjt", group: "Sales & Operations" },
  { t: "Supermarket Manager", c: 3, kind: "sjt", group: "Sales & Operations" },
];

// Letters and digits only, so "Front-end Developer" matches "Frontend Developer".
export function roleKey(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

export function findCatalogRole(name, roles = []) {
  const key = roleKey(name);
  if (!key) return null;
  return roles.find((role) => roleKey(role.t) === key) || null;
}

const ROLE_ACRONYMS = new Set(["qa", "hr", "ai", "it", "ui", "ux", "ml"]);

/** Last-resort label when a name is not in the catalog. Never leave a kebab slug. */
export function prettyRole(name) {
  const raw = String(name || "").trim();
  if (!raw) return "";
  if (!/[-_]/.test(raw) && /[A-Z]/.test(raw)) return raw;
  return raw
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word) => {
      const lower = word.toLowerCase();
      if (ROLE_ACRONYMS.has(lower)) return lower.toUpperCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}

/** Always show the catalog name. Never leave a kebab slug on screen. */
export function displayRole(name, roles = PARTNER_ROLE_CATALOG) {
  return findCatalogRole(name, roles)?.t || prettyRole(name);
}

const GROUP_ORDER = [
  "Technology & Digital",
  "Sales & Operations",
  "Business & Finance",
  "Creative & Design",
];

export function mergePartnerRoleCatalog(apiRoles = []) {
  const byKey = new Map(PARTNER_ROLE_CATALOG.map((role) => [roleKey(role.t), { ...role }]));
  const extras = [];
  for (const role of apiRoles) {
    const name = String(role?.t || "").trim();
    if (!name) continue;
    const key = roleKey(name);
    const existing = byKey.get(key);
    if (existing) {
      if (Number.isFinite(role.c)) existing.c = role.c;
      if (role.kind === "sjt") existing.kind = "sjt";
      if (role.group) existing.group = role.group;
      continue;
    }
    extras.push({
      t: displayRole(name),
      c: Number.isFinite(role.c) ? role.c : 0,
      kind: role.kind === "sjt" ? "sjt" : "mcq",
      group: String(role.group || "").trim(),
    });
  }
  extras.sort((a, b) => a.t.localeCompare(b.t));
  return [...PARTNER_ROLE_CATALOG.map((role) => byKey.get(roleKey(role.t))), ...extras];
}

export function roleOptionGroups(roles) {
  const named = new Map();
  const ungrouped = [];
  for (const role of roles) {
    if (!role.group) {
      ungrouped.push(role);
      continue;
    }
    if (!named.has(role.group)) named.set(role.group, []);
    named.get(role.group).push(role);
  }
  const known = GROUP_ORDER.filter((name) => named.has(name)).map((name) => ({
    name,
    roles: named.get(name),
  }));
  const rest = Array.from(named.keys())
    .filter((name) => !GROUP_ORDER.includes(name))
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({ name, roles: named.get(name) }));
  const groups = [...known, ...rest];
  if (ungrouped.length) groups.push({ name: groups.length ? "Other" : "", roles: ungrouped });
  return groups;
}
